import { useMemo } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

export type ShopFnbFacilityCarouselCountVariant = 'pill' | 'inline';

interface ShopFnbFacilityCarouselCountProps {
    contrast: boolean;
    page: number;
    totalPage: number;
    tabIndex: number;
    id?: string;
    /** `pill` (default): FnB/Facility grey capsule. `inline`: shop carousel plain "1 / N". */
    variant?: ShopFnbFacilityCarouselCountVariant;
    dataRegionOrder?: number;
}

const ShopFnbFacilityCarouselCount = ({
    contrast,
    page,
    totalPage,
    tabIndex,
    id = '',
    variant = 'pill',
    dataRegionOrder,
}: ShopFnbFacilityCarouselCountProps) => {
    const { t } = useTranslation();

    const countClassname = useMemo(() => {
        if (variant === 'inline') {
            return clsx(styles['count--inline'], contrast && styles['count--inline--contrast']);
        }
        return clsx(styles.count, contrast ? styles['count__contrast'] : '');
    }, [contrast, variant]);

    return (
        <div
            id={id}
            data-region-nav
            data-region-order={dataRegionOrder}
            className={countClassname}
            tabIndex={tabIndex}
            data-interactive
            aria-label={t('shop.pagination_desc', { page, total: totalPage })}
        >
            <span className={clsx('number', styles['count__page'])}>{page}</span>
            <span className={clsx('number', styles['count__slash'])}>/</span>
            <span className={clsx('number', styles['count__total'])}>{totalPage}</span>
        </div>
    );
};

export default ShopFnbFacilityCarouselCount;
